import { EnumAmbiente } from "@env/enum-ambiente";

export const environment = {
    permissaoAmbiente: 'Teste',
    ambiente: EnumAmbiente.Desenvolvimento,
    identidade: {
        clientId: 'identidade',
        apiUrl: 'https://identidadeapi-dev.blueroute.com.br/api',
        login: 'https://identidade-dev.blueroute.com.br/login'
    },
    catalogoConfiguracao: {
        clientId: 'cat-conf',
        apiUrl: 'https://catalogoconfapi-dev.blueroute.com.br/api'
    },
    catalogoOperacao: {
        clientId: 'cat-ope',
        apiUrl: 'https://catalogoopeapi-dev.blueroute.com.br/api',
        autenticacaoPortalUnico: '',
        treinamento: 'https://treinamento-dev.blueroute.com.br'
    },
    treinamento: {
        clientId: 'treinamento',
        apiUrl: 'https://treinamentoapi-dev.blueroute.com.br/api',
    },
    processadorSolicitacao: {
        apiUrl: 'https://catalogosolapi-dev.blueroute.com.br/api',
    },
    classificacaoConfiguracao: {
        clientId: 'cla-conf',
        apiUrl: 'https://classificacaoconfapi-dev.blueroute.com.br/api'
    },
    classificacaoOperacao: {
        clientId: 'cat-ope',
        apiUrl: 'https://classificacaoopeapi-dev.blueroute.com.br/api'
    },
    classificacaoProcessadorSolicitacao: {
        apiUrl: 'https://classificacaosolapi-dev.blueroute.com.br/api',
    },
    recaptcha: {
        siteKey: '6Lcq4cotAAAAAFw_h4gJ2HECTblXEvx_nA0ZL34b',
    },
    centralOperacao: {
        clientId: 'central',
        apiUrl: 'https://centralopeapi-dev.blueroute.com.br/api'
    },
    centralProcessadorSolicitacao: {
        apiUrl: 'https://centralsolapi-dev.blueroute.com.br/api'
    },
};
